import React, { cloneElement } from 'react';
import Cookies from 'js-cookie';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Page, withModel, } from '@adobe/aem-react-editable-components';
import { getGlobalCurrencyRate } from '@yme/api';
import { setInitialCartState as setInitialCartStateAction } from '@yme/common/redux/cart/actions';
import { getCart as getCartService, getExternalCart as getExternalCartService, } from '@yme/common/redux/cart/services';
import { getPDPLinks as getPDPLinksService } from '@yme/common/redux/common/services';
import { BroadcastChannels, CartBroadcastEvents } from '@yme/common/utils/constants';
import { CheckoutSteps } from '@yme/components/CheckoutForm/constants';
import { reloadPage } from '@yme/utils/common';
import { IS_VISUAL_WEBSITE_OPTIMIZER_ENABLED_KEY } from './common/constants';
import { COOKIE_CART_ID_KEY } from './common/redux/cart/constants';
import { ModalWindows } from './modals';
import { OneTrustHelper } from './one-trust/OneTrustHelper';
import { withTranslation } from './services/i18n';
export const broadcastCart = new BroadcastChannel(BroadcastChannels.CART);
// This component is the application entry point
class App extends Page {
    componentDidMount() {
        const { languageRootPath, isVisualWebsiteOptimizerEnabled, getPDPLinks, getCart, getExternalCart, setInitialCartState, currencyConverterConfig, getCurrencyRate, } = this.props;
        const currencyRatesHyperdriveEndpoint = currencyConverterConfig?.currencyRatesHyperdriveEndpoint ?? '';
        const nationalCurrencyCode = currencyConverterConfig?.nationalCurrencyCode ?? '';
        getCurrencyRate(currencyRatesHyperdriveEndpoint, nationalCurrencyCode);
        getPDPLinks(languageRootPath);
        getExternalCart();
        broadcastCart.onmessage = (message) => {
            if (message.data === CartBroadcastEvents.CART_FROM_URL) {
                getCart('', true);
                return;
            }
            if (window.location.hash === `#${CheckoutSteps.SUCCESS}` &&
                message.data === CartBroadcastEvents.CART_UPDATED) {
                !Cookies.get(COOKIE_CART_ID_KEY) && setInitialCartState();
                return;
            }
            if ([CartBroadcastEvents.ADD_NEW_PRODUCT, CartBroadcastEvents.REMOVE_PRODUCT].includes(message.data) &&
                [
                    `#${CheckoutSteps.SHIPPING_DETAILS}`,
                    `#${CheckoutSteps.ORDER_REVIEW}`,
                    `#${CheckoutSteps.SUCCESS}`,
                ].includes(window.location.hash)) {
                window.location.hash = `#${CheckoutSteps.CART}`;
                getCart('', true);
            }
            else {
                reloadPage();
            }
        };
        try {
            const isVisualWebsiteOptimizerEnabledFromStorage = sessionStorage.getItem(IS_VISUAL_WEBSITE_OPTIMIZER_ENABLED_KEY);
            if (!isVisualWebsiteOptimizerEnabledFromStorage) {
                sessionStorage.setItem(IS_VISUAL_WEBSITE_OPTIMIZER_ENABLED_KEY, JSON.stringify(isVisualWebsiteOptimizerEnabled));
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    componentWillUnmount() {
        broadcastCart.close();
    }
    render() {
        const { labels, isInAuthor, commercetoolsProjectKey, externalCart, locale, isoCountryCode, ecommerceEnabled, isInstallmentEnabled, isCycleSchemeEnabled, locationMismatchModalModel, configuratorLeadFormPagePath, dealerLocatorPageUrl, financeCalculatorLeadFormPagePath, bloomreachModel, searchResultsPageUrl, isOmnibusRegulationEnabled, anniversary70thLogoPagePath, currencyConverterConfig, } = this.props;
        const isCurrencyConverterEnabled = currencyConverterConfig?.isCurrencyConverterEnabled ?? false;
        return (React.createElement(React.Fragment, null,
            this.childComponents,
            this.childPages.map((page) => cloneElement(page, {
                labels: {
                    ...labels,
                    ...(page.props.labels || {}),
                },
                isInAuthor,
                commercetoolsProjectKey,
                configuratorLeadFormPagePath,
                externalCart,
                isOmnibusRegulationEnabled,
                locale,
                isoCountryCode,
                ecommerceEnabled,
                isInstallmentEnabled,
                isCycleSchemeEnabled,
                financeCalculatorLeadFormPagePath,
                locationMismatchModalModel,
                dealerLocatorPageUrl,
                bloomreachModel,
                isCurrencyConverterEnabled,
                searchResultsPageUrl,
                anniversary70thLogoPagePath,
            })),
            React.createElement(ModalWindows, null),
            React.createElement(OneTrustHelper, null)));
    }
}
const mapDispatchToProps = {
    getPDPLinks: getPDPLinksService,
    getCart: getCartService,
    getExternalCart: getExternalCartService,
    getCurrencyRate: getGlobalCurrencyRate,
    setInitialCartState: setInitialCartStateAction,
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const AppComponent = withTranslation(withModel(withRouter(App)), [
    'locationMismatchModalModel.labels',
]);
export default connect(null, mapDispatchToProps)(AppComponent);
